<template>
  <v-dialog :value="isOpen" width="500" @input="$emit('closed')">
    <v-card>
      <v-card-title class="subheading font-weight-bold px-4">
        <span>Add Population Group</span>
        <v-spacer></v-spacer>
        <v-icon @click="$emit('closed')">close</v-icon>
      </v-card-title>

      <v-divider></v-divider>
      <v-form ref="form" @submit.prevent="doAddPopulationGroup">
        <v-container class="px-4">
          <app-alert
            class="mb-3"
            type="error"
            :message="error"
            :outline="true"
            @dismissed="error = false"
          />
          <v-layout justify-space-between row wrap>
            <v-flex xs12 sm6>
              <v-select
                label="Category"
                v-model="group.beneficiary_id"
                :items="beneficiaryCategories"
                :disabled="isLoading"
                :rules="[rules.isRequired]"
                @input="canSave = true"
                required
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field
                label="Count"
                type="number"
                v-model="group.value"
                :rules="[rules.isNumber]"
                @input="canSave = true"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout class="mt-4 mb-2">
            <v-btn depressed color="accent" type="submit" :disabled="isSaving || !canSave">
              Save
              <v-progress-circular
                class="ml-3"
                :indeterminate="true"
                :size="18"
                :width="2"
                v-if="isSaving"
              ></v-progress-circular>
            </v-btn>
            <v-btn depressed @click="$emit('closed')">Cancel</v-btn>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { setFormData } from '@/utils/http'

export default {
	name: 'AddBeneficiary',
	props: ['isOpen', 'type', 'typeId', 'agent', 'beneficiaries'],
	data () {
		return {
			group: {
        type: this.type,
				value: '',
				beneficiary_id: '',
				type_id: this.typeId,
				agent_id: this.agent
			},
			canSave: false,
			isSaving: false,
			isLoading: false,
			error: false,
      rules: {
        isRequired: value => value && value.trim() === '' ? 'Please select a category' : true,
        isNumber: value => ((value && value.trim()) === '' || isNaN(value) || value < 1) ? 'Category count is required' : true
      }
		}
	},
	computed: {
    beneficiaryCategories () {
      const beneficiaryCategories = this.$store.getters.categoriesAsOptions('beneficiary')
      const addedBeneficiaries = this.beneficiaries.map(beneficiary => {
				return beneficiary.beneficiary_id
      })

      return beneficiaryCategories.filter(beneficiary => {
				return !addedBeneficiaries.includes(beneficiary.value)
			})
    }
	},
	methods: {
		doAddPopulationGroup () {
      if (!this.$refs.form.validate()) return

      this.isSaving = true
      this.error = false

      const group = {
        value: this.group.value,
        agent_id: this.group.agent_id,
        beneficiary_id: this.group.beneficiary_id,
        [this.group.type + '_id']: this.group.type_id
      }
			const params = setFormData(group)
      this.$http.post(this.group.type + '_beneficiary/create', params)
        .then(({ data: response }) => {
          if (response.code === 200) {
						group._id = response.data
						this.$emit('saved', group)
						this.$refs.form.reset()
						this.$emit('closed')
					}
          else {
						this.error = response.message
					}
				})
				.finally(() => {
					this.canSave = false
					this.isSaving = false
				})
		}
	}
}
</script>
